import ApiTypes from "../types/apiTypes";
import { config } from "../../config/config";

export const pingRequest = () => ({
  type: ApiTypes.PING_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/ping`,
        method: "GET"
      },
      commit: { type: ApiTypes.PING_SUCCESS },
      rollback: { type: ApiTypes.PING_FAILURE }
    }
  }
});

export const getUserInfoRequest = (username: string) => ({
  type: ApiTypes.GET_USER_INFO,
  username,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/user/${username}`,
        method: "GET"
      },
      commit: { type: ApiTypes.GET_USER_INFO_SUCCESS },
      rollback: { type: ApiTypes.GET_USER_INFO_FAILURE }
    }
  }
});

/**
 * Search employees by login or name for autocomplete
 * GET /common/search/people?query={login}&size=1000
 * Note: skipAuthRedirect=true prevents page refresh on CORS/401 errors
 * since this is a non-critical autocomplete request
 */
export const trackFeatureRequest = (payload: {
  feature_id: string;
  feature: string;
  pvid: string;
  sub_feature?: string;
  system?: string;
}) => ({
  type: ApiTypes.TRACK_FEATURE_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/tracking/metrics`,
        method: "POST",
        json: payload,
      },
      commit: { type: ApiTypes.TRACK_FEATURE_SUCCESS },
      rollback: { type: ApiTypes.TRACK_FEATURE_FAILURE },
    },
  },
});

export const searchEmployeeRequest = (login: string) => ({
  type: ApiTypes.SEARCH_EMPLOYEE_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/common/search/people?query=${encodeURIComponent(login)}&size=1000`,
        method: "GET",
        skipAuthRedirect: true,
      },
      commit: { type: ApiTypes.SEARCH_EMPLOYEE_SUCCESS },
      rollback: { type: ApiTypes.SEARCH_EMPLOYEE_FAILURE },
    },
  },
});

export const searchTeamRequest = (query: string) => ({
  type: ApiTypes.SEARCH_TEAM_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/common/search/teams?query=${encodeURIComponent(query)}&size=1000`,
        method: "GET",
        skipAuthRedirect: true,
      },
      commit: { type: ApiTypes.SEARCH_TEAM_SUCCESS },
      rollback: { type: ApiTypes.SEARCH_TEAM_FAILURE },
    },
  },
});
